import _ from "lodash";
import { useCallback, useEffect, useState } from "react";
import { CountFilter, FindFilter } from "../model/model/filter/Filter";
import { Paging } from "../model/model/filter/Paging";
import { ListFilter } from "../model/model/filter/Filter";
import { BaseModel } from "../model/model/BaseModel";
import { BaseController } from "../controller/fake/BaseController";

export function useCrudHook<T extends BaseModel>(props: Props<T>) {
	const basePath = props.basePath
	const [state, setState] = useState<State<T>>({
		isShowConfirm: false,
		isShowPopup: false,
		itemSelected: {} as T,
	});
	const [query, setQuery] = useState<ListFilter<T>>({
		page : 1,
		pageSize : 10,
	})

	const [pagingList, setPagingList] = useState<Paging<T>>({
		page : 1,
		pageSize : 10,
		rows : [],
		total : 0,
		totalPages : 1,
	})

	const onConfirm = (item: T) => {
		setState({
			...state,
			itemSelected: item,
			isShowConfirm: true,
		});
	};

	const onShowPopup = (item: T) => {
		setState({
			...state,
			isShowPopup: true,
			itemSelected: item,
			isShowConfirm: false,
		});
	};

	const onDelete = (item: T) => {
		if (props.controller && item.id) {
			props.controller.delete(item.id).then((res) => {
				setQuery({...query})
				setState({
					isShowPopup: false,
					isShowConfirm: false,
					itemSelected: {} as T,
				});
			});
		}else{
			if(props.onDelete){
				props.onDelete(item);
			}
		}
	};

	const onSave = (item: T) => {
		if (props.controller) {
			props.controller.save({...item}).then((res) => {
				if(props.onSave){
					props.onSave(res);
				}
				setState({
					isShowPopup: false,
					isShowConfirm: false,
					itemSelected: {} as T,
				});
				if(!props.isSetQueryWhenSave){
					if(item.id){
						
					}else{
						let list = pagingList.rows || [];
						list.push(res);
						setPagingList({
							...pagingList,
							rows : list,
							total : (pagingList.total || 0) +1 ,
							page : pagingList.page,
							

						})
					}
				}else{
					setQuery({...query})
				}
				// todo : set paging
			});
		}else{
			if(props.onSave){
				props.onSave(item)
			}
		}
	};

	const onCancelConfirm = () => {
		setState({
			...state,
			isShowConfirm: false,
			itemSelected: {} as T,
		});
	};

	const onCancelPopup = () => {
		setState({
			...state,
			isShowPopup: false,
			itemSelected: {} as T,
		});
	};

	const onQueryChanged = useCallback(
		_.debounce((value: string) => {
			setQuery({ ...query, search: value, page : 1 });
		}, props.delaySearch || 400),
		[]
	);

	useEffect(() => {
		if(props.controller){
			props.controller?.list(query).then(res=>{
				setPagingList(res);
			})
		}
	}, [query])
	
	return {
		onConfirm,
		onDelete,
		onSave,
		onShowPopup,
		onCancelConfirm,
		onCancelPopup,
		setQuery,
		setPagingList,
		onQueryChanged,
		isShowConfirm: state.isShowConfirm,
		isShowPopup: state.isShowPopup,
		itemSelected: state.itemSelected,
		pagingList,
		query,
	};
}

type State<T> = {
	itemSelected: T;
	isShowConfirm: boolean;
	isShowPopup: boolean;
};

interface  Props<T>  {
	controller ?: BaseController<T>;
	onDelete?:(item: T)=> void;
	onSave?: (item: T)=> void;
	onQuery?: (query: ListFilter<T>) => void;
	basePath?: string
	/**
	 * @description millisecond
	 * */ 
	delaySearch ?: number 
	isSetQueryWhenSave ?: boolean
	isSetQueryWhenDelete ?: boolean 
};

